import React, { FC } from 'react';

import { useField } from 'formik';

import { FormControl, FormLabel, Stack, Switch, Text } from '@chakra-ui/react';

import { UrlSwitchProps } from './UrlSwitch.props';

const UrlSwitchView: FC<UrlSwitchProps> = (props) => {
  const [field, , helpers] = useField(props.name);

  return (
    <FormControl mt={4} mb={4}>
      <FormLabel fontSize="14px" color="#Afafaf" textTransform="capitalize">
        Portal
      </FormLabel>
      <Stack isInline>
        <Text>Enable Portal</Text>
        <Switch
          isChecked={field.value}
          colorScheme="primary"
          display="flex"
          alignItems="center"
          isReadOnly={props.isReadOnly}
          onChange={(e) => {
            helpers.setValue(e.target.checked);

            props.onChange?.(e);
          }}
        />
      </Stack>
    </FormControl>
  );
};

export default UrlSwitchView;
